import React from "react";
import "../styles/loader.scss";

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader">
        <div className="dot" />
        <div className="dot" />
        <div className="dot" />
      </div>
      <p>Učitavanje...</p>
    </div>
  );
};

export default Loader;
